<template>
    <b-container fluid class="">
        <b-row class="justify-content-between flex-center noMargin">
            <b-col cols="12" md="6">
                <h3>{{ $t('events.list')}}</h3>
            </b-col>
            <b-col cols="12" md="6">
                <b-btn v-b-modal.createEvent variant="primary" class="my-2 float-right"><span class="fa fa-calendar-plus mx-2"></span> {{ $t('events.button')}}</b-btn>
            </b-col>
        </b-row>

        <hr/>
        <b-container fluid class="dashboardTile p-4 shadow-lg noMargin">
            <b-row v-if="events" class="noMargin">
            <b-col>
                <events-table position
                              search-key="name"
                              :items="events"
                              :fields="eventsFields"
                              @rowClicked="goToEvent">
                    <template slot="Index" slot-scope="data">
                        {{data.index}}
                    </template>
                </events-table>
            </b-col>
        </b-row>

        </b-container>

        


        <b-modal centered
                 size="xl"
                 hide-footer
                 no-close-on-backdrop
                 id="createEvent"
                 ok-only
                 ok-variant="success">
            <b-row class="py-2 my-2 flex-center text-center d-lg-none">
                <b-col cols="12" class="d-md-none">
                    <h6>{{eventStep + 1}} / 5</h6>
                </b-col>
                <b-col cols="12" lg="2" style="color: #1c2331;" v-if="eventStep === 0">
                    <h5>1. {{ $t('events.modal.create')}}</h5>
                </b-col>
                <b-col cols="12" lg="2" style="color: #1c2331;" v-if="eventStep === 1">
                    <h5>2. {{ $t('events.modal.design')}}</h5>
                </b-col>
                <b-col cols="12" lg="3" style="color: #1c2331;" v-if="eventStep === 2">
                    <h5>3. {{ $t('events.modal.prepaid')}}</h5>
                </b-col>
                <b-col cols="12" lg="3" style="color: #1c2331;" v-if="eventStep === 3">
                    <h5>4. {{ $t('events.modal.generate')}}</h5>
                </b-col>
                <b-col cols="12" lg="2" style="color: #1c2331;" v-if="eventStep === 4">
                    <h5>5. {{ $t('events.modal.print')}}</h5>
                </b-col>
            </b-row>
            <b-row class="py-2 my-2 flex-center text-center">
                <b-col cols="12" lg="2" class="d-none d-lg-block" style="color: #1c2331;" v-if="eventStep === 0">
                    <h5>1. {{ $t('events.modal.create')}}</h5>
                </b-col>
                <b-col cols="12" lg="2" class="d-none d-lg-block" style="color: #BDBDBD;" v-else>
                    <h5>1. {{ $t('events.modal.create')}}</h5>
                </b-col>
                <b-col cols="12" lg="2" class="d-none d-lg-block" style="color: #1c2331;" v-if="eventStep === 1">
                    <h5>2. {{ $t('events.modal.design')}}</h5>
                </b-col>
                <b-col cols="12" lg="2" class="d-none d-lg-block" style="color: #BDBDBD;" v-else>
                    <h5>2. {{ $t('events.modal.design')}}</h5>
                </b-col>
                <b-col cols="12" lg="3" class="d-none d-lg-block" style="color: #1c2331;" v-if="eventStep === 2">
                    <h5>3. {{ $t('events.modal.prepaid')}}</h5>
                </b-col>
                <b-col cols="12" lg="3" class="d-none d-lg-block" style="color: #BDBDBD;" v-else>
                    <h5>3. {{ $t('events.modal.prepaid')}}</h5>
                </b-col>
                <b-col cols="12" lg="3" class="d-none d-lg-block" style="color: #1c2331;" v-if="eventStep === 3">
                    <h5>4. {{ $t('events.modal.generate')}}</h5>
                </b-col>
                <b-col cols="12" lg="3" class="d-none d-lg-block" style="color: #BDBDBD;" v-else>
                    <h5>4. {{ $t('events.modal.generate')}}</h5>
                </b-col>
                <b-col cols="12" lg="2" class="d-none d-lg-block" style="color: #1c2331;" v-if="eventStep === 4">
                    <h5>5. {{ $t('events.modal.print')}}</h5>
                </b-col>
                <b-col cols="12" lg="2" class="d-none d-lg-block" style="color: #BDBDBD;" v-else>
                    <h5>5. {{ $t('events.modal.print')}}</h5>
                </b-col>
            </b-row>
            <b-row class="py-1">
                <b-col cols="12">
                    <hr/>
                </b-col>
            </b-row>
            <b-row class="p-4 my-2 flex-center">
                <b-col md="12" class="">
                    <b-form @submit.prevent="next()" v-if="eventStep === 0" data-vv-scope="createEvent">
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label-for="eventName">{{ $t('events.modal.name')}} 
                                    <b-form-input  :state="validateState('createEvent.eventName')"
                                                   :class="{'is-invalid': veeErrors.has('createEvent.eventName')}"
                                                   v-validate="'required|min:6'" v-model="event.name" id="eventName" ref="eventName" type="text" size="md" name="eventName" :placeholder="$t('placeholders.name')"></b-form-input>
                                    <span class="vvError">{{ veeErrors.first('createEvent.eventName') }}</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="6">
                                <b-form-group label-for="date">{{ $t('events.modal.date')}}
                                    <date-picker format="DD.MM.YYYY."
                                                 type="date"
                                                 v-model="event.date"
                                                 :not-before="new Date()"
                                                 :lang="$parent[$i18n.locale]"
                                                 :first-day-of-week="1"
                                                 class="w-100"
                                                 name="date"
                                                 v-validate="'required'"
                                                 id="date">
                                    </date-picker>
                                    <span class="vvError">{{ veeErrors.first('createEvent.date') }}</span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label-for="date_from">{{ $t('events.modal.start')}}
                                    <date-picker format="YYYY-MM-DD HH:mm:ss"
                                                 name="dateFrom"
                                                 v-validate="'required'"
                                                 v-model="event.date_from"
                                                 :not-before="event.date||new Date()"
                                                 :not-after="event.date_to"
                                                 :lang="$parent[$i18n.locale]"
                                                 type="datetime"
                                                 :minute-step="10"
                                                 :first-day-of-week="1"
                                                 class="w-100"
                                                 id="date_from">
                                    </date-picker>
                                    <span class="vvError">{{ veeErrors.first('createEvent.dateFrom') }}</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="6">
                                <b-form-group label-for="date_to">{{ $t('events.modal.end')}}
                                    <date-picker format="YYYY-MM-DD HH:mm:ss"
                                                 name="dateTo"
                                                 v-validate="'required'"
                                                 v-model="event.date_to"
                                                 :not-before="event.date_from||new Date()"
                                                 :lang="$parent[$i18n.locale]"
                                                 type="datetime"
                                                 :minute-step="10"
                                                 :first-day-of-week="1"
                                                 class="w-100"
                                                 id="date_to">
                                    </date-picker>
                                    <span class="vvError">{{ veeErrors.first('createEvent.dateTo') }}</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" class="flex-center py-2">
                                <b-form-group label=""
                                              label-for="ticketSectorRadio"
                                              name="sectorType">
                                    <b-form-radio v-model="event.sectorType" name="ticketSectorRadio" inline value="1">{{ $t('events.modal.without')}}</b-form-radio>
                                    <b-form-radio v-model="event.sectorType" name="ticketSectorRadio" inline value="2">{{ $t('events.modal.with')}}</b-form-radio>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" ld="6" class="text-center">
                                <b-btn type="submit" :disabled="veeErrors.any('createEvent')" variant="primary" class="float-right w-25">{{ $t('events.modal.switch.next')}}</b-btn>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-col>
                <b-col cols="12">
                    <b-form @submit.prevent="createEvent()" v-if="eventStep === 1" data-vv-scope="createEventDetails">
                        <b-row>
                            <b-col cols="12" lg="4">
                                <b-row>
                                    <b-col cols="12">
                                        <b-form-group label-for="headlineA"> {{ $t('events.modal.headline.a')}}
                                            <b-form-input :state="validateState('createEventDetails.headlineA')"
                                                          :class="{'is-invalid': veeErrors.has('createEventDetails.headlineA')}"
                                                          v-validate="'required|min:6'" v-model="event.headline_a" id="headlineA" ref="headlineA" type="text" size="md" name="headlineA" :placeholder="$t('placeholders.headlineA')"></b-form-input>
                                            <span class="vvError">{{ veeErrors.first('createEventDetails.headlineA') }}</span>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12">
                                        <b-form-group label-for="headlineA"> {{ $t('events.modal.headline.a')}}
                                            <b-form-input :state="validateState('createEventDetails.headlineB')"
                                                          :class="{'is-invalid': veeErrors.has('createEventDetails.headlineB')}"
                                                          v-validate="'required|min:4'" v-model="event.headline_b" id="headlineB" ref="headlineB" type="text" size="md" name="headlineB" :placeholder="$t('placeholders.headlineB')"></b-form-input>
                                            <span class="vvError">{{ veeErrors.first('createEventDetails.headlineB') }}</span>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12">
                                        <b-form-group label-for="lineA"> {{ $t('events.modal.line.a')}}
                                            <b-form-input v-model="event.line_a" id="lineA" ref="lineA" type="text" size="md" name="lineA" :placeholder="$t('placeholders.lineA')"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12">
                                        <b-form-group label-for="lineB"> {{ $t('events.modal.line.b')}}
                                            <b-form-input v-model="event.line_b" id="lineB" ref="lineB" type="text" size="md" name="lineB" :placeholder="$t('placeholders.lineB')"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="12" lg="8" class="d-none d-lg-block"  v-if="eventStep === 1">
                                <b-row class="py-2">
                                    <b-col cols="12" class="text-center">
                                        <h5>{{ $t('ticket_scan.preview')}}</h5>
                                    </b-col>
                                </b-row>
                                <b-row class="py-4">
                                    <b-col cols="6">
                                        <h4 class="mx-4 px-4">{{event.headline_a}}</h4>
                                        <h5 class="mx-4 px-4">{{event.headline_b}}</h5>
                                        <h6 class="mx-4 px-4">{{event.line_a}}</h6>
                                        <h6 class="mx-4 px-4">{{event.line_b}}</h6>
                                    </b-col>
                                    <b-col cols="4" class="text-right">
                                        <h6>{{$t('ticket_scan.sector')}} A</h6>
                                        <h6>{{$t('ticket_scan.row')}} 5</h6>
                                        <h6>{{$t('ticket_scan.seat')}} 17</h6>
                                    </b-col>
                                    <b-col cols="2" class="text-right">
                                        <b-img :src="require('../../assets/img/barcode.png')" fluid alt="profile.png"/>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4" class="text-center">
                                <b-btn @click="back" variant="primary" class="float-left w-100">{{ $t('events.modal.switch.back')}}</b-btn>
                            </b-col>
                            <b-col cols="4" class="text-center">
                            </b-col>
                            <b-col cols="4" class="text-center">
                                <b-btn type="submit" variant="primary" :disabled="veeErrors.any('createEventDetails')" class="float-right w-100">{{ $t('events.modal.switch.next')}}</b-btn>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-col>
                <b-col md="12" class="">
                    <b-form @submit.prevent="eventPrepaidGroups()" v-if="eventStep === 2 && groups.length > 0" data-vv-scope="addGroup">
                        <b-row>
                            <b-col cols="12" lg="6">
                                <h5 class="text-center">{{ $t('events.modal.all')}}</h5>
                                <b-list-group>
                                    <b-list-group-item v-if="!group.selected" href="#" variant="secondary" @click="addGroup(group)" v-for="group in groups">
                                        <span>{{group.name}} </span>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-col>
                            <b-col cols="12" class="d-md-none">
                                <hr/>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <h5 class="flex-center">{{ $t('events.modal.selected')}}</h5>
                                <b-list-group>
                                    <b-list-group-item v-if="group.selected" href="#" variant="success" @click="removeGroup(group)" v-for="group in groups">{{group.name}}</b-list-group-item>
                                </b-list-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" class="py-2 text-center">
                                <p style="font-style: italic;" >
                                    {{ $t('events.modal.note')}}
                                </p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="6" class="text-center">
                            </b-col>
                            <b-col cols="12" lg="6" class="text-center">
                                <b-btn type="submit" :disabled="veeErrors.any('addGroup')" variant="primary" class="float-right w-25">{{ $t('events.modal.switch.next')}}</b-btn>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-row v-else-if="eventStep === 2 && groups.length === 0">
                        <b-col cols="12">
                            <b-row class="flex-center flex-column">
                                <h4 class="text-center">
                                    {{$t('noData.groups.msg')}}
                                </h4>
                                <p style="font-style: italic;" >
                                    {{$t('noData.groups.msg')}}
                                </p>
                            </b-row>
                            <b-row>
                                <b-col cols="6" class="text-center">
                                </b-col>
                                <b-col cols="6" class="text-center">
                                    <b-btn @click="next2" :disabled="veeErrors.any('addGroup')" variant="primary" class="float-right w-25">{{ $t('events.modal.switch.next')}}</b-btn>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="12" class="">
                    <b-form @submit.prevent="generateTickets()" v-if="eventStep === 3">
                        <b-row v-show="event.with_sectors === false">
                            <b-col cols="6">
                                <b-form-group label-for="ticketsAmount">{{$t('events.modal.num')}}
                                    <b-form-input :state="validateState('generateTickets.ticketsAmount')"
                                                  :class="{'is-invalid': veeErrors.has('generateTickets.ticketsAmount')}"
                                                  v-validate="event.with_sectors === false ? 'required|min_value:1':''" v-model="tickets.amount"
                                                  id="ticketsAmount" ref="ticketsAmount" type="number" size="md" name="ticketsAmount"></b-form-input>
                                    <span class="vvError">{{ veeErrors.first('generateTickets.ticketsAmount') }}</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="6">
                                <b-form-group label-for="ticketTypeRadio"
                                              name="ticketType">{{$t('events.modal.type')}}<br>
                                    <b-form-radio v-model="tickets.type" name="ticketTypeRadio" default inline value="1">{{$t('events.modal.radio.paper')}}</b-form-radio>
                                    <b-form-radio v-model="tickets.type" name="ticketTypeRadio" inline value="2">{{$t('events.modal.radio.rfid')}}</b-form-radio>
                                </b-form-group>
                            </b-col>
                        </b-row>
                         <b-row v-show="event.with_sectors === true">
                            <b-col cols="12" lg="6">
                                <h5 class="text-center">{{$t('events.modal.allSectors')}}</h5>
                                <b-list-group>
                                    <b-list-group-item v-if="!sector.selected" @click="addSector(sector)" href="#" variant="secondary" v-for="sector in sectors" v-bind:key="sector.id">
                                        <span> {{ sector.code }} </span>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-col>
                            <b-col cols="12" class="d-md-none">
                                <hr/>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <h5 class="flex-center">{{$t('events.modal.selectedSectors')}}</h5>
                                <b-list-group>
                                    <b-list-group-item v-if="sector.selected" @click="removeSector(sector)" href="#" variant="success" v-for="sector in sectors" v-bind:key="sector.id">
                                        <span> {{ sector.code }} </span>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-col>
                         </b-row>
                        <b-row v-show="eventStep === 3 && sectors.length === 0 && event.with_sectors === true">
                            <b-col cols="12" class="py-2 text-center">
                                <p style="font-style: italic;" >
                                    {{$t('events.modal.tip')}}
                                </p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="6" class="text-center">
                            </b-col>
                            <b-col cols="6" lg="6" class="text-center">
                                    <b-btn type="submit" :disabled="veeErrors.any('generateTickets')" variant="primary" class="float-right w-50">{{ $t('events.modal.switch.next')}}</b-btn>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-row v-if="eventStep === 3 && sectors.length === 0">
                        <b-col cols="12">
                            <b-row class="flex-center flex-column">
                                <h4 class="text-center">
                                    {{$t('sectors.no')}}
                                </h4>
                                <p style="font-style: italic;" >
                                    {{$t('sectors.tip')}}
                                </p>
                            </b-row>
                            <b-row>
                                <b-col cols="6" class="text-center">
                                </b-col>
                                <b-col cols="6" lg="6" class="text-center">
                                    <b-btn type="submit" :disabled="veeErrors.any('generateTickets')" variant="primary" class="float-right w-25">{{ $t('events.modal.switch.next')}}</b-btn>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="12" class="">
                    <b-form @submit.prevent="ticketsPrint()" v-if="eventStep === 4"  data-vv-scope="printTickets">
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label-for="printName">{{ $t('events.modal.job')}}
                                    <b-form-input :state="validateState('printTickets.printName')"
                                                  :class="{'is-invalid': veeErrors.has('printTickets.printName')}"
                                                  v-validate="'required|min:3'" v-model="printTickets.name" id="printName" ref="printName" type="text" size="md" name="printName"></b-form-input>
                                    <span class="vvError">{{ veeErrors.first('printTickets.printName') }}</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="6">
                                <b-form-group label-for="printerID">{{ $t('events.modal.id')}}
                                    <b-form-input :state="validateState('printTickets.printerID')"
                                                  :class="{'is-invalid': veeErrors.has('printTickets.printerID')}"
                                                  v-validate="'required|min_value:1'" v-model="printTickets.printer_id" id="printerID" ref="printerID" type="number" size="md" name="printerID"></b-form-input>
                                    <span class="vvError">{{ veeErrors.first('printTickets.printerID') }}</span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label-for="printAmount">{{ $t('events.modal.to_print')}}
                                    <b-form-input :state="validateState('printTickets.printAmount')"
                                                  :class="{'is-invalid': veeErrors.has('printTickets.printAmount')}"
                                                  v-validate="`required|max_value:${this.printableTickets}|min_value:1`" v-model="printTickets.amount"
                                                  id="printAmount" ref="printAmount" type="number" size="md" name="printAmount"></b-form-input>
                                    <span class="vvError">{{ veeErrors.first('printTickets.printAmount') }}</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="6">
                                <p>
                                    {{ $t('events.modal.available')}}
                                </p>
                                <p class="text-center">
                                    {{printableTickets}}
                                </p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" lg="6" class="text-center">
                            </b-col>
                            <b-col cols="12" lg="6" class="text-center">
                                <b-btn type="submit" :disabled="veeErrors.any('printTickets')" variant="primary" ref="btnPrint" class="float-right w-50">{{ $t('events.modal.print_Button')}}</b-btn>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-col>
            </b-row>
        </b-modal>
    </b-container>
</template>

<script>
    // @ is an alias to /src
    export default {
        name: 'events',
        data() {
            return {
                eventStep: 0,
                events: null,
                groups: {},
                events: null,
                printError: ('toast.printError'),
                selectedGroup: {},
                groupsString: '',
                sectorsString: '',
                tickets:{
                    type: "1",
                    sector: null,
                    amount: 0,
                },
                printableTickets: 0,
                printTickets: {
                    printer_id: 1,
                },
                event: {
                    sectorType: "1",
                },
                eventsFields: [
                    {
                        key: 'name',
                        labelPath: 'table.events.name',
                        sortable: true
                    },
                    {
                        key: 'total',
                        labelPath: 'table.events.total',
                        sortable: true
                    },
                    {
                        key: 'date',
                        labelPath: 'table.events.date',
                        sortable: true,
                        thClass: 'd-none d-lg-table-cell',
                        tdClass: 'd-none d-lg-table-cell' ,
                        formatter: (value) => this.$moment(value).format("DD.MM.YYYY.")
                    },
                ],
                sectors: null,
            }
        },
        methods: {
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            back(){
                this.eventStep -= 1;
            },
            next(){
                this.$validator.validateAll('createEvent').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                           message : this.$t(this.printError)
                        });
                    }else{
                        this.eventStep += 1;
                    }
                }).then(()=> {
                        this.$nextTick(() => {
                            this.veeErrors.clear();
                            this.$nextTick(() => {
                                this.$validator.reset();
                            });
                        });
                    }
                );
            },
            next2(){
                this.eventStep += 1;
            },
            goToEvent(id) {
                this.$router.push('/events/' + id)
            },
            getEvents(){
                this.$axios.get('eventsDash').then(response => {
                    if (response.data.success) {
                        this.events = response.data.data;
                    }
                })
            },
            createEvent(){
                this.$validator.validateAll('createEventDetails').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                            message : this.$t(this.printError)
                        });
                    }else{
                        this.$axios.post('events/create',
                            this.event
                        ).then(response => {
                            if(response.data.success) {
                                this.event = response.data.data.event;
                                this.$toasted.global.success({
                                    message : this.$t(response.data.data.msg)
                                });
                                this.eventStep += 1;
                            }
                        }).then(()=> {
                                this.$nextTick(() => {
                                    this.veeErrors.clear();
                                    this.$nextTick(() => {
                                        this.$validator.reset();
                                    });
                                });
                            }
                        );
                    }
                });
            },
            groupsArrayToString(){
                let self=this;
                this.groups.forEach(function(item){
                    if(item.selected){
                        self.groupsString += item.id + ',';
                    }
                });
                this.groupsString = this.groupsString.substring(0, this.groupsString.length - 1)
            },
             sectorsArrayToString(){
                let self=this;
                this.sectors.forEach(function(item){
                    if(item.selected){
                        self.sectorsString += item.id + ',';
                    }
                });
                this.sectorsString = this.sectorsString.substring(0, this.sectorsString.length - 1)
            },
            addGroup(group){
                this.$validator.validateAll('addGroup').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                            message : this.$t(this.printError)
                        });
                    }else{
                        group.selected = true;
                    }
                }).then(()=> {
                        this.$nextTick(() => {
                            this.veeErrors.clear();
                            this.$nextTick(() => {
                                this.$validator.reset();
                            });
                        });
                    }
                );
            },
            removeGroup(group){
                group.selected = false;
            },
            addSector(sector){
                sector.selected = true;
            },
            removeSector(sector){
                sector.selected = false;
            },
            eventPrepaidGroups(){
                this.groupsArrayToString();
                this.$validator.validateAll('addGroup').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                            message : this.$t(this.printError)
                        });
                    }else{
                        this.$axios.post('events/addPrepaid',{
                                params: {
                                    eventID: this.event.id,
                                    prepaidGroups: this.groupsString
                                }
                            }
                        ).then(response => {
                            if(response.data.success) {
                                this.$toasted.global.success({
                                    message : this.$t(response.data.msg)
                                });
                                this.eventStep += 1;
                            }
                        }).then(()=> {
                                this.$nextTick(() => {
                                    this.veeErrors.clear();
                                    this.$nextTick(() => {
                                        this.$validator.reset();
                                    });
                                });
                            }
                        );
                    }
                });
            },
            generateTickets(){
                this.sectorsArrayToString();

                if(this.event.with_sectors === false){
                    this.sectorsString = null;
                }
                
                this.$validator.validateAll('generateTickets').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                            message : this.$t(this.printError)
                        });
                    }else{
                        this.$axios.post('events/generateTickets', {
                                params: {
                                    event: this.event,
                                    tickets: this.tickets,
                                    sectors: this.sectorsString
                                }
                            }
                        ).then(response => {
                            if (response.data.success) {
                                this.tickets = response.data.data;
                                this.$toasted.global.success({
                                    message : this.$t(response.data.data.msg)
                                });
                                this.eventStep += 1;
                            }
                        }).then(()=> {
                                this.$nextTick(() => {
                                    this.veeErrors.clear();
                                    this.$nextTick(() => {
                                        this.$validator.reset();
                                    });
                                });
                            }
                        );
                    }
                });
            },
            getPrintableTickets(){
                this.$axios.get('/events/printableTickets',
                    {
                        params: {
                            id: this.event.id
                        }
                    }
                ).then(response => {
                    if (response.status === 200) {
                        this.printableTickets = response.data.data.tickets_amount;
                    }
                })
            },
            ticketsPrint(){
                this.$validator.validateAll('printTickets').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                            message : this.$t(this.printError)
                        });
                    }else{
                        this.$axios.post('printJobs/printTickets', {
                                params: {
                                    event: this.event,
                                    printTickets: this.printTickets
                                }
                            }
                        ).then(response => {
                            if(response.data.success) {
                                this.printTickets = response.data.data;
                                this.$root.$emit('bv::hide::modal', 'createEvent', '#btnPrint');
                                this.$toasted.global.success({
                                    message : this.$t(response.data.data.msg)
                                });
                                this.eventStep = 0;
                                this.event = {};
                                this.tickets = {
                                    type: "1",
                                    sectorType: "1",
                                    sector: null,
                                    amount: 0,
                                };
                                this.printTickets = {
                                    printer_id: 1,
                                };
                            }
                        }).then(()=> {
                                this.$nextTick(() => {
                                    this.veeErrors.clear();
                                    this.$nextTick(() => {
                                        this.$validator.reset();
                                    });
                                });
                            }
                        );
                    }
                });
            },
            getSectors(){
                this.$axios.get('sectors').then(response => {
                    if (response.status === 200) {
                        response.data.data.forEach(function(item){
                            item.selected = false;
                        });
                        this.sectors = response.data.data;
                    }
                })
            },
            getPrepaidGroups(){
                this.$axios.get('prepaid/groups').then(response => {
                    if (response.status === 200) {
                        response.data.data.forEach(function(item){
                            item.selected = false;
                        });
                        this.groups = response.data.data;
                    }
                })
            },
        },
        created() {
            let self = this;
            this.getEvents();
            this.getSectors();
            this.getPrepaidGroups();
            this.interval = setInterval(function () {
                self.getEvents();
                self.getPrintableTickets();
            }, 5000);
        },
        destroyed(){
            clearInterval(this.interval);
        },
    };
</script>